<forge-card class="no-padding">
    <forge-toolbar>
        <h2 class="forge-typography--heading4">Employee Lookup</h2>
    </forge-toolbar>

    <div [formGroup]="formGroup">
        <lgd-typeahead fxFlex controlName="employee" label="Employee" (searchTextChanged)="lookupEmployees($event)"
            [options]="employeesObservable" style="margin: 1rem 1rem -1rem;">
        </lgd-typeahead>
    </div>

    @if (infoCard) {
    <info-card [(item)]="infoCard" [criteria]="infoCardCriteria" [outlined]="true" [saveable]="true">
    </info-card>
    }
</forge-card>